export const transformToNegativeLog = (matrix: number[][]): number[][] => {
  return matrix.map((row) =>
    row.map((rate) => (rate <= 0 ? 0 : -Math.log10(rate) || 0)),
  );
};
